<template>
  <v-container class="layout-container">
    <BaseHeader
      title="Termine &amp; Fortbildung"
      :style-variant="7"
    >
      <template
        v-if="!isPlatformBottimmo"
        v-slot:design
      >
        <HeaderDesign />
      </template>

      <template v-slot:desc>
        <p>
          {{ $t('labels.timetable-training-info') }}
          {{ $t('labels.register-now') }}
        </p>
      </template>
      <template v-slot:content>
        <v-breadcrumbs :items="breadcrumbItems" />
      </template>
    </BaseHeader>
    <v-col
      cols="12"
      class="pa-0"
    >
      <calendar />
    </v-col>
  </v-container>
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue'
import brandingMixin from '@/mixins/branding.js'
import Calendar from '@/modules/calendar'
import HeaderDesign from '@/modules/calendar/HeaderDesign.vue'

export default {
  components: {
    Calendar,
    BaseHeader,
    HeaderDesign,
  },
  mixins: [brandingMixin],
  computed: {
    breadcrumbItems() {
      return [
        {
          title: this.$t('navigation.labels.support'),
          to: '/support',
          disabled: false,
          exact: true,
        },
        { title: this.$t('labels.calendar') },
      ]
    },
  },
}
</script>
